export const convertToValidHTMLId = (str = "") => {
  return str.replace(/[^a-z0-9]/gi, "_").toLocaleLowerCase();
};
